module.exports = __webpack_public_path__ + "img/rugby.fef7bdf1.svg";